import RecurrenceMonthly from './RecurrenceMonthly';

export default RecurrenceMonthly;
